import { render } from "./ManagePostType.vue?vue&type=template&id=6a223e0e"
import script from "./ManagePostType.vue?vue&type=script&lang=js"
export * from "./ManagePostType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__